import axiosInstance from '@/config/axios';
import { IApplication, IApplicationGroup } from '@/types/appliction';
import { useQuery } from '@tanstack/react-query';

export const useUserApplicationList = () =>
  useQuery({
    queryFn: () => axiosInstance.get<IApplicationGroup[]>('user-applications'),
    queryKey: ['user-applications'],
    select: (res) => res.data,
    gcTime: 0,
  });

export const useGetApplication = (id?: string) =>
  useQuery({
    queryFn: () => axiosInstance.get<IApplication>(`applications/${id}`),
    queryKey: ['application', id],
    select: (res) => res.data,
    gcTime: 0,
    enabled: !!id,
  });
